import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography
} from "@mui/material";
import { Form, FormikValues, useFormikContext } from "formik";
import moment from "moment";
import { FC, useCallback, useEffect } from "react";

import CreatePageFormFooter from "../../../../../common/Form/CreatePageFormFooter/CreatePageFormFooter";
import ProgressSteps from "../../../../../common/ProgressSteps/ProgressSteps";

import { useFindOneMeetingLazyQuery } from "../../../../../../generated/graphql";
import useAppStore from "../../../../../../states/zustand/appStore";
import { IProps } from "../../../../../../types/EC/ec";
import FileUploadButton from "../../../../../common/Form/FileUpload/FileUploadButton";
import InputField from "../../../../../common/Form/Input/InputField";
import { REQUIRED_DOC } from "../../../utils";
import DropdownWithOther from "../../../../IRB/IRBSubmission/CreateIRBSubmission/StudyDetails/DropdownWithOther";
import { MEETING_TYPE } from "../../../../../../constants";

interface MeetingProps extends IProps {
  id?: string;
}

const CreateMeeting: FC<MeetingProps> = (props): JSX.Element => {
  const { id, steps, setSteps, stepsInfo } = props;
  const { setValues } = useFormikContext<FormikValues>();
  const { setLoader } = useAppStore();
  const [getMeeting, { loading }] = useFindOneMeetingLazyQuery();

  const fetchMeeting = useCallback(async (id: string) => {
    let res = await getMeeting({
      variables: {
        _id: id,
      },
    });

    let data = res.data?.findOneMeeting;
    if (data) {
      let body = {
        meetingType: data?.meetingType,
        meetingId: data?.meetingId,
        meetingDate: moment(data?.meetingDate).format("yyyy-MM-DD"),
        lastSubmissionDate: moment(data?.lastSubmissionDate).format(
          "yyyy-MM-DD"
        ),
        agenda: data?.agenda,
        // mom: data?.mom,
        projects: data?.projects?.map((p) => {
          return {
            _id: {
              label: p._id.title,
              value: p._id._id,
            },
            documents: p.documents.map((d) => ({
              label: d.label,
              required: REQUIRED_DOC.includes(d.label) ? true : false,
              url: d.url,
              isEditable: REQUIRED_DOC.includes(d.label) ? false : true,
              isInputOpened: REQUIRED_DOC.includes(d.label) ? false : true,
            })),
          };
        }),
      };
      setValues(body);
    }
  }, []);

  useEffect(() => {
    if (id) {
      fetchMeeting(id);
    }
  }, [id]);

  useEffect(() => {
    setLoader(loading);
  }, [loading]);
  return (
    <Form>
      <>
        <Card>
          <CardContent className="pd-x-32 pd-t-32 pd-b-20">
            <Typography className="mg-b-10" variant="h2" component="h2">
              {id ? `Edit Meeting` : `New Meeting`}
            </Typography>
            <ProgressSteps stepsInfo={stepsInfo} currentStep={steps} />
            <Divider className={`mg-b-32`} />
            <Grid container className="justify-content-center">
              <Grid item xs={12} md={10} lg={10}>
                <DropdownWithOther
                  options={[MEETING_TYPE.MIEC, MEETING_TYPE.MIRB, MEETING_TYPE.MSMC]}
                  label={"1. Meeting Type"}
                  name={"meetingType"}
                  placeholder={"Short Text"}
                  disabled={false}
                />
                <InputField
                  type="text"
                  label={"2.  Meeting ID"}
                  className="mg-b-50"
                  name="meetingId"
                  placeholder=""
                />
                <InputField
                  type="date"
                  label={"3. MIRB /EC Meeting Date"}
                  className="mg-b-50"
                  name="meetingDate"
                  placeholder=""
                />
                {/* <InputField
                  type="date"
                  label={"4.  Last date of submission"}
                  className="mg-b-50"
                  name="lastSubmissionDate"
                  placeholder=""
                /> */}

                <Box className="mg-b-50">
                  <label className="form-label mg-b-20">4. Agenda</label>
                  <FileUploadButton
                    name="agenda"
                    label="Upload"
                    className="mg-t-0"
                  />
                </Box>
              </Grid>
            </Grid>
            <CreatePageFormFooter
              setSteps={setSteps}
              steps={steps}
              stepsInfo={stepsInfo}
            />
          </CardContent>
        </Card>
      </>
    </Form>
  );
};

export default CreateMeeting;
